"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InMemoryStorageCSFactory = void 0;
var SplitsCacheInMemory_1 = require("./SplitsCacheInMemory");
var MySegmentsCacheInMemory_1 = require("./MySegmentsCacheInMemory");
var ImpressionsCacheInMemory_1 = require("./ImpressionsCacheInMemory");
var EventsCacheInMemory_1 = require("./EventsCacheInMemory");
var ImpressionCountsCacheInMemory_1 = require("./ImpressionCountsCacheInMemory");
var constants_1 = require("../../utils/constants");
var TelemetryCacheInMemory_1 = require("./TelemetryCacheInMemory");
/**
 * InMemory storage factory for standalone client-side SplitFactory
 *
 * @param params parameters required by EventsCacheSync
 */
function InMemoryStorageCSFactory(params) {
    return {
        splits: new SplitsCacheInMemory_1.SplitsCacheInMemory(),
        segments: new MySegmentsCacheInMemory_1.MySegmentsCacheInMemory(),
        impressions: new ImpressionsCacheInMemory_1.ImpressionsCacheInMemory(params.impressionsQueueSize),
        impressionCounts: params.optimize ? new ImpressionCountsCacheInMemory_1.ImpressionCountsCacheInMemory() : undefined,
        events: new EventsCacheInMemory_1.EventsCacheInMemory(params.eventsQueueSize),
        telemetry: params.mode !== constants_1.LOCALHOST_MODE && (0, TelemetryCacheInMemory_1.shouldRecordTelemetry)() ? new TelemetryCacheInMemory_1.TelemetryCacheInMemory() : undefined,
        // When using MEMORY we should clean all the caches to leave them empty
        destroy: function () {
            this.splits.clear();
            this.segments.clear();
            this.impressions.clear();
            this.impressionCounts && this.impressionCounts.clear();
            this.events.clear();
        },
        // When using shared instanciation with MEMORY we reuse everything but segments (they are unique per key)
        shared: function () {
            return {
                splits: this.splits,
                segments: new MySegmentsCacheInMemory_1.MySegmentsCacheInMemory(),
                impressions: this.impressions,
                impressionCounts: this.impressionCounts,
                events: this.events,
                telemetry: this.telemetry,
                // Set a new splits cache to clean it for the client without affecting other clients
                destroy: function () {
                    this.splits = new SplitsCacheInMemory_1.SplitsCacheInMemory();
                    this.segments.clear();
                }
            };
        },
    };
}
exports.InMemoryStorageCSFactory = InMemoryStorageCSFactory;
InMemoryStorageCSFactory.type = constants_1.STORAGE_MEMORY;
